import React, { useEffect, useState } from "react";
import PublicNavbar from "../components/layout/PublicNavbar";
import Footer from "../components/layout/Footer";
import { toast, Toaster } from "sonner";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../lib/AuthContext";
import { Input, TextArea, Button, Select } from "../components/common/Primitives";
import Seo from "../components/Seo";

export default function Support() {
  const { user } = useAuth();
  const [form, setForm] = useState({ subject: "", message: "", priority: "normal" });
  const [tickets, setTickets] = useState([]);

  const load = () => {
    if (user) api.get("/support/tickets").then((r) => setTickets(r.data)).catch(() => {});
  };
  useEffect(load, [user]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/support/ticket", form);
      toast.success("Ticket raised. Our team will respond shortly.");
      setForm({ subject: "", message: "", priority: "normal" });
      load();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div className="min-h-screen bg-transparent text-ink">
      <Seo
        title="Support | Contact the VenturaZ Team"
        description="Raise a ticket, request a callback, or browse FAQs. Median response time under 6 business hours from the VenturaZ support team."
        path="/support"
      />
      <Toaster richColors position="top-right" />
      <PublicNavbar />
      <section className="max-w-[1200px] mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-2 gap-12">
        <div>
          <div className="overline mb-3">SUPPORT</div>
          <h1 className="font-display text-4xl lg:text-5xl text-ink leading-tight">We&apos;re here for serious participants.</h1>
          <p className="text-ink-muted mt-5 leading-relaxed">Raise a ticket, request a callback, or browse FAQs. Median response time under 6 business hours.</p>
          <div className="mt-8 border border-white/10 bg-white/70 backdrop-blur p-6">
            <div className="overline mb-3">Contact</div>
            <div className="text-sm text-ink-soft font-body">support@venturaz.com</div>
            <div className="text-sm text-ink-muted font-body mt-1">Mon–Fri · 9:00 to 19:00 IST</div>
          </div>
        </div>

        {user ? (
          <form onSubmit={submit} className="border border-white/10 bg-white/70 backdrop-blur p-6 space-y-4" data-testid="support-ticket-form">
            <Input label="Subject" testId="ticket-subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} required />
            <Select label="Priority" testId="ticket-priority" value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value })}>
              <option value="low">Low</option>
              <option value="normal">Normal</option>
              <option value="high">High</option>
              <option value="urgent">Urgent</option>
            </Select>
            <TextArea label="Message" testId="ticket-message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required />
            <Button type="submit" data-testid="ticket-submit-btn">Raise Ticket</Button>

            {tickets.length > 0 && (
              <div className="pt-6 border-t border-white/10 mt-6">
                <div className="overline mb-3">Recent Tickets</div>
                <div className="space-y-2">
                  {tickets.slice(0, 5).map((t) => (
                    <div key={t.ticket_id} className="flex items-center justify-between text-sm">
                      <div className="text-ink-soft truncate">{t.subject}</div>
                      <div className="text-[11px] font-mono uppercase text-gold">{t.status}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </form>
        ) : (
          <div className="border border-white/10 bg-white/70 backdrop-blur p-6 text-ink-soft text-sm">
            Please <a href="/login" className="text-gold underline">login</a> to raise a support ticket.
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
